import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useRequestData, usePrefs } from 'wsm-common-data';
import VehicleTitle from '../components/VehicleTitle';
import useVehicleViews from '../hooks/useVehicleViews';
import { isExistAttrConfig } from '../utils/utility';
import { highlightedAttrs, SIDEBAR_CLASS } from '../global-constants';

const Widget = () => {
	const { deviceType } = useRequestData();
	const prefs = usePrefs();

	const vehicle = useSelector((state) => state.vehicle);
	const highlightedAttrsConfig = useSelector(
		(state) => state.highlightedAttrsConfig
	);

	const shouldRequestVehicleViews = isExistAttrConfig(
		highlightedAttrsConfig,
		highlightedAttrs.VEHICLE_VIEWS
	);
	const { hasViewsData, numberOfViews } = useVehicleViews(
		vehicle.vin,
		prefs.vehicleViews_timeFrame,
		shouldRequestVehicleViews
	);

	if (vehicle) {
		let portal;
		const isDesktop = deviceType === 'DESKTOP';
		// Put VehicleTitle component in the sidebar of some VDPs on desktop
		if (isBrowser && isDesktop) {
			const [container] = document.querySelectorAll(`.${SIDEBAR_CLASS}`);
			if (container) {
				portal = ReactDOM.createPortal(
					<VehicleTitle
						isInSidebar
						hasViewsData={hasViewsData}
						numberOfViews={numberOfViews}
					/>,
					container
				);
			}
		}
		return (
			<div
				data-display-sets="SUPPLEMENTAL_TITLE"
				// eslint-disable-next-line react/no-unknown-property -- read by composer-ui display-config-panel.js
				hide-base-facet-category="true"
			>
				<VehicleTitle
					hasViewsData={hasViewsData}
					numberOfViews={numberOfViews}
				/>
				{portal}
			</div>
		);
	}
	return null;
};

export default Widget;
